export const aciPackages = {
    iconName: 'packages',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M18.177 21.03H5.824c-2.348 0-4.324-1.976-4.324-4.323v-5.93c0-2.346 1.976-4.323 4.324-4.323h12.353c2.346 0 4.323 1.977 4.323 4.324v5.929c0 2.347-1.977 4.324-4.323 4.324zM5.824 7.69c-1.73 0-3.089 1.482-3.089 3.088v5.929a3.058 3.058 0 003.089 3.088h12.353a3.058 3.058 0 003.088-3.088v-5.93a3.058 3.058 0 00-3.088-3.088H5.824z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M7.43 21.03c-.371 0-.618-.247-.618-.617V7.072c0-.37.247-.618.617-.618.371 0 .618.247.618.618v13.34c0 .372-.37.619-.618.619zM16.57 21.03c-.37 0-.617-.247-.617-.617V7.072c0-.37.247-.618.617-.618.371 0 .618.247.618.618v13.34c0 .372-.247.619-.617.619zM15.335 7.441c-.37 0-.617-.247-.617-.617V4.476c0-.37-.37-.74-.742-.74h-3.952c-.371 0-.742.37-.742.74v2.348c0 .37-.247.617-.617.617s-.618-.37-.618-.741V4.476c0-1.111.865-1.976 1.977-1.976h3.953c1.111 0 1.976.865 1.976 1.976v2.348c0 .247-.37.617-.618.617z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
